import React from "react";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "../../Collections/Imports";
import Alert from "@mui/material/Alert";

/** What Save will change, from the API's dry run. */
const SaveDialog = ({ open, result, saving, onCancel, onConfirm, title = "Save tree changes?" }) => {
  const diff = result?.diff || {};
  const lines = [];
  (diff.tree || []).forEach((c) => lines.push(`Tree ${c.field}: ${JSON.stringify(c.from)} → ${JSON.stringify(c.to)}`));
  (diff.added || []).forEach((c) => lines.push(`Add ${c.buyerName || ""} · ${c.campaignName} (#${c.uniqueId})`));
  (diff.removed || []).forEach((c) => lines.push(`Remove ${c.buyerName || ""} · ${c.campaignName} (#${c.uniqueId ?? c.campaignId})`));
  (diff.campaignChanges || []).forEach((c) =>
    lines.push(
      `${c.campaignName} (#${c.uniqueId}) ${c.field}: ${c.from ?? "none"} → ${c.to ?? "none"}${
        c.scope === "campaign" ? " (every tree)" : ""
      }`
    )
  );
  return (
    <Dialog open={open} onClose={saving ? undefined : onCancel} maxWidth="md" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent dividers>
        {lines.length === 0 ? (
          <Typography>No changes to the tree or its campaigns.</Typography>
        ) : (
          <Box component="ul" sx={{ pl: 3, m: 0 }}>
            {lines.map((l, i) => (
              <li key={i}>
                <Typography variant="body2">{l}</Typography>
              </li>
            ))}
          </Box>
        )}
        <Typography variant="body2" sx={{ mt: 1 }}>
          Walk order {diff.orderChanged ? "changes" : "does not change"}.
        </Typography>
        {(result?.warnings || []).length > 0 && (
          <Alert severity="warning" sx={{ mt: 1 }}>
            {(result.warnings || []).map((w, i) => (
              <div key={i}>{w.message}</div>
            ))}
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={saving}>
          Cancel
        </Button>
        <Button variant="contained" onClick={onConfirm} disabled={saving} style={{ color: "#fff" }}>
          {saving ? "Saving…" : "Save"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SaveDialog;
